"use strict";

var _interopRequireDefault = require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = _interopRequireDefault(require("@/store"));
const state = {
  overseas_form: {}
};
const mutations = {
  OVERSEAS_DATA: (state, form_data) => {
    state.overseas_form = form_data;
  }
};
const actions = {
  setOverseasDatas({
    commit
  }, data) {
    commit('OVERSEAS_DATA', data);
  }
};
var _default = exports.default = {
  namespaced: true,
  state,
  mutations,
  actions
};